import * as React from "react";
import { SVGProps, memo } from "react";

const SvgWebCall = (props: SVGProps<SVGSVGElement>) => (
  <svg width={50} height={61} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <mask id="WebCall_svg__a" fill="#fff">
      <path d="M29.217 61H3.694a3.165 3.165 0 0 1-3.18-3.176V13.175A3.165 3.165 0 0 1 3.695 10h25.523a3.165 3.165 0 0 1 3.18 3.177v44.647A3.165 3.165 0 0 1 29.217 61Z" />
    </mask>

    <path
      d="M29.217 61H3.694a3.165 3.165 0 0 1-3.18-3.176V13.175A3.165 3.165 0 0 1 3.695 10h25.523a3.165 3.165 0 0 1 3.18 3.177v44.647A3.165 3.165 0 0 1 29.217 61Z"
      fill="#C2CCD6"
      stroke="#2B323B"
      strokeWidth={3.2}
      mask="url(#WebCall_svg__a)"
    />

    <path d="M30.012 12.47H2.988v37.412h27.024V12.47Z" fill="#fff" />

    <path
      d="M18.884 55.087A2.374 2.374 0 0 1 16.5 57.47a2.374 2.374 0 0 1-2.385-2.383 2.374 2.374 0 0 1 2.385-2.382 2.374 2.374 0 0 1 2.384 2.382Z"
      fill="#2B323B"
    />

    <circle cx={16.742} cy={28.546} r={4.636} fill="#2B323B" />

    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.47 39.364v2.318h17.772v-2.318c0-2.134-3.979-3.864-8.886-3.864-4.908 0-8.887 1.73-8.887 3.864Z"
      fill="#2B323B"
    />

    <mask id="WebCall_svg__b" fill="#fff">
      <path d="M24.485 24V1.946c0-.54.187-1 .562-1.378A1.843 1.843 0 0 1 26.408 0h21.154c.534 0 .988.19 1.362.568.374.379.561.838.561 1.378V17.73c0 .54-.187 1-.56 1.378a1.843 1.843 0 0 1-1.363.568H28.76L24.485 24Z" />
    </mask>

    <path
      d="M24.485 24V1.946c0-.54.187-1 .562-1.378A1.843 1.843 0 0 1 26.408 0h21.154c.534 0 .988.19 1.362.568.374.379.561.838.561 1.378V17.73c0 .54-.187 1-.56 1.378a1.843 1.843 0 0 1-1.363.568H28.76L24.485 24Z"
      fill="#D0EAFB"
      stroke="#000"
      strokeWidth={3.2}
      mask="url(#WebCall_svg__b)"
    />

    <g clipPath="url(#WebCall_svg__c)" fill="#1395EC">
      <circle cx={31.257} cy={10} r={2} />

      <circle cx={37.257} cy={10} r={2} />

      <circle cx={43.257} cy={10} r={2} />
    </g>

    <defs>
      <clipPath id="WebCall_svg__c">
        <path fill="#fff" transform="translate(29.257 8)" d="M0 0h16v4H0z" />
      </clipPath>
    </defs>
  </svg>
);

const Memo = memo(SvgWebCall);

export default Memo;
